import { Link } from 'gatsby'
import React from 'react'
import Helmet from 'react-helmet'
import { Waypoint } from 'react-waypoint'
import pic01 from '../assets/images/n.webp'
import Header from '../components/header'
import Layout from '../components/layout'
import Nav from '../components/Nav'
import ContactForm from '../components/ContactForm'

import { FaTwitter} from "react-icons/fa";
import {FaFacebook} from "react-icons/fa";
import {FaGooglePlus }from "react-icons/fa";
import {FaPinterest }from "react-icons/fa";
import {FaEnvelope }from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { ShareButtonRectangle, ShareBlockStandard } from "react-custom-share";


class Index extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      stickyNav: false,
    }
  }

  _handleWaypointEnter = () => {
    this.setState(() => ({ stickyNav: false }))
  }

  _handleWaypointLeave = () => {
    this.setState(() => ({ stickyNav: true }))
  }

  render() {
    return (
      <Layout>
        <Helmet title="Find your ideal career path according to the Big 5 psychological trait model" />

        <Header />

        <Waypoint
          onEnter={this._handleWaypointEnter}
          onLeave={this._handleWaypointLeave}
        ></Waypoint>
         <Nav  />

        <div id="main">


          <section id="intro" className="main">
            <div className="spotlight">
              <div className="content">
                <header className="major">
                  <h2>Find your ideal career in 5 minutes!</h2>
                </header>
                <p>
                  The <b>Big Five personality traits</b>, also known as the OCEAN model, is a grouping for personality traits, developed in psychological trait theory. <br/>When factor analysis (a statistical technique) is applied to personality survey data, it reveals semantic associations: some words used to describe aspects of personality are often applied to the same person. For example, someone described as conscientious is more likely to be described as "always prepared" rather than "messy".<br/> These associations suggest five broad dimensions used in common language to describe the human personality, temperament and psyche. <br/>
                  This test will help you to find the best career orientation for you by <b>comparing your psychometrics with over 3000 careers from our vocations dataset</b>. Testing is based on the IPIP questionnaire.
                </p>

              </div>
              <span className="image">
                <img src={pic01} alt="" />
              </span>
            </div>
          </section>


          <section id="contactUs" className="main special">
              <header className="major">
          <h2>Big 5 career test</h2>

          <div align="left">
          <b>How to answer the questions:</b>
          <ol>
          <li>Almost never descriptive of me | Absolute NO | 1 star</li>

<li>Rarely descriptive of me</li>
<li>Sometimes descriptive of me</li>
<li>Usually descriptive of me</li>
<li>Almost always descriptive of me | Absolute YES | 5 stars</li>
    </ol>
      <h3>Answer all non-optional questions:</h3>
    <hr/>

          </div>
          <ContactForm ></ContactForm>

          </header>
          </section>








        </div>
      </Layout>
    )
  }
}

export default Index
